import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/pragmatic',
    name: 'pragmatic',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/PragmaticView.vue')
    }
  },
  {
    path: '/pgsoft',
    name: 'pgsoft',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/PGSoftView.vue')
    }
  },
  {
    path: '/spadegaming',
    name: 'spadegaming',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/SpadegamingView.vue')
    }
  },
  {
    path: '/habanero',
    name: 'habanero',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/HabaneroView.vue')
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
